<template>
  <div class="wrapper">
    <div
      v-if="cv"
      class="bg-card"
    >
      <div v-if="!isProfileCompleted">
        <div
          v-if="profileCompletion >= 100"
          class="mb-2"
        >
          <div class="m-auto d-flex flex-wrap justify-content-center">
            <vue-circle
              ref="progressId"
              :fill="fill"
              :progress="profileCompletion"
              :size="100"
              :show-percent="true"
            />
            <div class="ml-3 my-auto text-center">
              <div style="font-weight: 600; color: rgb(100, 100, 100);">
                {{ $t('pages.user-cv.sidebar.please-complete-profile', 'Please complete your profile') }}
              </div>
              <div style="font-weight: 400; color: rgb(153, 153, 153);}">
                {{
                  $t(
                    'pages.user-cv.sidebar.completion',
                    'It\'s at {perc} %',
                    { perc: profileCompletion }
                  )
                }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="!employmentCompleted || !cv.document">
          {{ $t('pages.user-cv.sidebar.necessary', 'Necessary') }}:
        </div>
        <b-button
          v-if="!employmentCompleted"
          class="cv-button --w-100"
          @click="$emit('levelsModalOpen')"
        >
          {{ $t('pages.user-cv.employment.edit-button', 'Edit employment status') }}
        </b-button>
        <b-button
          v-if="!cv.document"
          class="cv-button --w-100"
          @click="$emit('documentModalOpen')"
        >
          {{ $t('pages.user-cv.document.edit-button', 'Edit document') }}
        </b-button>
        <div v-if="!optionalCompleted">
          {{ $t('pages.user-cv.sidebar.optional', 'Optional') }}:
        </div>
        <b-button
          v-if="!cv.languages"
          class="cv-button --w-100"
          @click="$emit('langModalOpen')"
        >
          {{ $t('pages.user-cv.languages.edit-button', 'Edit languages') }}
        </b-button>
        <b-button
          v-if="!cv.skills"
          class="cv-button --w-100"
          @click="$emit('skillsModalOpen')"
        >
          {{ $t('pages.user-cv.skills.edit-button', 'Edit skills') }}
        </b-button>
        <b-button
          v-if="!cv.text_cv"
          class="cv-button --w-100"
          @click="$emit('textCvModalOpen')"
        >
          {{ $t('pages.user-cv.text-cv.edit-button', 'Edit CV in text') }}
        </b-button>
        <b-button
          v-if="!cv.educations"
          class="cv-button --w-100"
          @click="$emit('educationsModalOpen')"
        >
          {{ $t('pages.user-cv.education.edit-button', 'Edit education') }}
        </b-button>
        <b-button
          v-if="!cv.experience"
          class="cv-button --w-100"
          @click="$emit('experienceModalOpen')"
        >
          {{ $t('pages.user-cv.experience.edit-button', 'Edit experience') }}
        </b-button>
        <b-button
          v-if="!cv.recommendations"
          class="cv-button --w-100"
          @click="$emit('recommendedByModalOpen')"
        >
          {{ $t('pages.user-cv.my-recommendations.edit-button', 'Edit my recommendations') }}
        </b-button>
      </div>
      <div
        v-if="isProfileCompleted"
        class="text-center"
      >
        <img src="../../../assets/check-icon.png">
        <div
          class="mt-1"
          style="font-weight: 600; color: #999;"
        >
          {{ $t('pages.user-cv.sidebar.profile-completed', 'Profile completed!') }}
        </div>
      </div>
      <hr>
      <div class="last-update text-center">
        <div class="date">
          {{ shortUpdateDate }}
        </div>
        <div class="text">
          {{ $t('pages.user-cv.sidebar.last-updated', 'Your CV was last updated at') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCircle from 'vue2-circle-progress/src/index.vue'

export default {
  components: {
    VueCircle
  },
  props: {
    cv: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      langModalOpen: false,
      LevelsModalOpen: false,
      fill: { color: "#009090" }
    }
  },
  computed: {
    shortUpdateDate() {
      return this.cv.updated_at.substring(0,10).replace('-','/').replace('-','/');
    },
    isProfileCompleted() {
      return this.employmentCompleted && this.optionalCompleted;
    },
    employmentCompleted() {
      return this.cv.levels && this.cv.experience_time &&
        this.cv.categories && this.cv.industries &&
        this.cv.contracts;
    },
    optionalCompleted() {
      return this.cv.skills && this.cv.text_cv &&
        this.cv.educations && this.cv.experience &&
        this.cv.languages;
    },
    profileCompletion() {
      let percent = 1;
      if(this.cv.levels || this.cv.experience ||
        this.cv.languages || this.cv.categories ||
        this.cv.industries || this.cv.contracts) {
        percent++;
      }
      if(this.cv.languages) percent++;
      if(this.cv.skills) percent++;
      if(this.cv.text_cv) percent++;
      if(this.cv.educations) percent++;
      if(this.cv.experience) percent++;
      if(this.cv.document) percent++;

      return Math.round(percent / 8 * 100);
    }
  },
  watch: {
    profileCompletion(newValue) {
      this.$refs.progressId.updateProgress(newValue);
    }
  }
}
</script>

<style scoped lang="scss">
  .last-update {
    .date {
      font-weight: 600;
      font-size: 1.7rem;
    }

    .text {
      font-size: 0.8rem;
      color: #999;
    }
  }

  .my-cv {
    font-size: 0.8rem;

    .title {
      font-size: 1rem;;
    }
  }
</style>

<style lang="scss">
  .circle-percent-text-body {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>

